import ContractInvitationsTable from "./ContractInvitationsTable";

export default ContractInvitationsTable;
